"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var usePendingState_1 = require("./usePendingState");
exports.usePendingState = usePendingState_1.default;
//# sourceMappingURL=index.js.map